<template>
    <div class="page">
      <el-pagination background
        @current-change="handleSizeChange"
        @size-change="handlePagesizeChange"
        :current-page.sync="pagination.page"
        :page-size="pagination.pageSize"
        layout="sizes, prev, pager, next"
        :page-sizes="[10, 20, 50, 100]"
        :total="total">
      </el-pagination>
    </div>
</template>
<!--layout="total, prev, pager, next, jumper"-->

<script>
import {mapGetters} from 'vuex'
export default {
    name: 'page',
    props: ['total'],
    data() {
        return {
            pagination: {
                page: 1,
                pageSize: 10
            }
        }
    },
    created() {
        // this.pagination = this._.cloneDeep(this.page)
    },
    methods: {
        handleSizeChange(val) {
            this.pagination.page = val
            // let page = {page: val, pageSize: this.pagination.pageSize}
            // this.$store.commit('SET_PAGE', page)
            this.$emit('getList', this.pagination)
        },
        handlePagesizeChange(value) {
            this.pagination.page = 1
            this.pagination.pageSize = value
            // let page = {page: 1, pageSize: value}
            // this.$store.commit('SET_PAGE', page)
            this.$emit('getList', this.pagination)
        }
    },
    computed: {
        ...mapGetters([
            'page'
        ])
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.page {
    margin-top: 20px;
    @include flexBox(center);
    .el-pagination__sizes {
        .el-select  {
            .el-input {
                height: 28px;
                line-height: 28px;
                .el-input__inner {
                    height: 28px;
                }
            }
        }
    }

}
</style>
